/**
 * Created by mac on 9/20/25
 */

const Merge2CustomerRecipe = function (data) {
    this.index = data.index;
    this.eventOrder = data.eventOrder;

    this.ingredients = [];

    data.ingredients.forEach((ingredient) => {
        const same = this.ingredients.find((item) => Unit.Equals(item.unit, ingredient.unit));
        if (same) {
            same.amount++;
        } else {
            this.ingredients.push(ingredient);
        }

        if (Merge2CustomerRecipe.IsBigStageUnit(ingredient.unit)
            || Merge2CustomerRecipe.IsSecondLineMaxStageUnit(ingredient.unit) && (same || ingredient.amount > 1)) {
            this.isAutoOrder = true;
        }

        if (Unit.isSideQuest(ingredient.unit.code)) {
            this.sideQuest = Merge2Customers.getSideQuestGenerator(ingredient.unit.code).code;
        }
    });

    this.bonus = [
        { ingredient: "orderStar", amount: this.calcOrderStars() }
    ];
};

Merge2CustomerRecipe.prototype.calcOrderStars = function () {
    let orderStars = 0;
    this.ingredients.forEach((ingredient) => {
        orderStars += Merge2CustomerRecipe._getStarsBonuses(ingredient.unit);
    });
    return orderStars;
};

Merge2CustomerRecipe.prototype.calcStagesInIngredients = function () {
    let stagesInIngredients = 0;
    this.ingredients.forEach((ingredient) => {
        stagesInIngredients += ingredient.unit.stage + 1;
    });
    return stagesInIngredients;
};

Merge2CustomerRecipe._getStarsBonuses = function (ingredient) {
    const stage = ingredient.stage;
    let code = ingredient.code;
    if (Unit.isSideQuest(code)) {
        return 0;
    }
    if (!Merge2CustomerRecipe.STARS_BONUSES[code] || Merge2CustomerRecipe.STARS_BONUSES[code][stage] === undefined) {
        cleverapps.throwAsync(`bonus stars not set for ingredient: code ${code}, stage ${stage}`);
        code = "a";
    }

    return Merge2CustomerRecipe.STARS_BONUSES[code][stage] || 0;
};

Merge2CustomerRecipe.prototype.listPrize = function () {
    const prizes = [];

    this.bonus.forEach((item) => {
        if (item.ingredient) {
            prizes.push(item);
        }
    });

    return prizes;
};

Merge2CustomerRecipe.prototype.prizesToRewards = function () {
    if (this.sideQuest) {
        return Merge2Customers.SIDE_QUEST_REWARDS[this.sideQuest];
    }

    let rewards = {};

    this.listPrize().forEach((prize) => {
        rewards[prize.ingredient] = prize.amount;
    });

    if (cleverapps.energyBooster.isActive()) {
        rewards.energy = cleverapps.energyBooster.getOrderEnergy(this.ingredients);
    }

    const missionRewards = [];

    cleverapps.missionManager.getRunningMissions().filter((m) => m.logic && m.logic.getOrderRewards).forEach((mission) => {
        const reward = mission.logic.getOrderRewards(this);

        if (!reward) {
            return;
        }

        if (reward.missionType) {
            missionRewards.push(reward);
        } else {
            rewards = RewardsList.sumRewards(rewards, reward);
        }
    });

    if (missionRewards.length) {
        rewards = { mission: missionRewards, ...rewards };
    }

    return rewards;
};

Merge2CustomerRecipe.prototype.isEnoughIngredients = function () {
    return this.ingredients.every((ingredient) => Merge2.current.stock.getLackingAmount(ingredient) === 0);
};

Merge2CustomerRecipe.prototype.getIngredients = function () {
    return this.ingredients;
};

Merge2CustomerRecipe.prototype.getBonusStar = function () {
    return this.bonus.filter((item) => item.ingredient === "orderStar")[0];
};

Merge2CustomerRecipe.IsBigStageUnit = function (unit) {
    return unit.stage >= OrdersAlgoConfig.lines[unit.code] && OrdersAlgoHelper.GeneratorForItem(unit.code, OrdersAlgoHelper.DefaultGenerators());
};

Merge2CustomerRecipe.IsSecondLineMaxStageUnit = function (unit) {
    return ["b", "d", "h", "f"].includes(unit.code) && unit.stage === OrdersAlgoConfig.lines[unit.code] - 1
        && OrdersAlgoHelper.GeneratorForItem(unit.code, OrdersAlgoHelper.DefaultGenerators());
};

Merge2CustomerRecipe.STARS_BONUSES = { // https://docs.google.com/spreadsheets/d/1rT4MdK0eggOG4mkrLHG2ObZIvVaNmnuTer6OYiebxIc/edit?gid=91406180#gid=91406180
    a: [0, 1, 2, 4, 8, 12, 20, 32, 50, 78, 116, 180, 284, 418, 636, 1020],
    b: [2, 4, 8, 14, 24, 36, 56, 88, 132, 202, 318, 476, 716],
    c: [0, 1, 2, 4, 8, 14, 24, 36, 56, 88, 132, 202, 318, 476, 716],
    d: [2, 4, 8, 14, 24, 36, 56, 88],
    e: [2, 4, 8, 14, 24, 36, 56, 88, 132, 202, 318],
    f: [2, 4, 8, 14, 24, 36, 56, 88],
    g: [2, 4, 8, 14, 24, 36, 56, 88, 132, 202, 318, 476, 716],
    h: [4, 8, 12, 22, 34, 54, 88, 122],
    i: [2, 4, 8, 14, 24, 36, 56, 88, 132, 202, 318, 476, 716]
};

if (typeof cc === "undefined") {
    module.exports = Merge2CustomerRecipe;
}